import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let SearchCategoryTitle = class SearchCategoryTitle extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "categoryTitle", void 0);
    _defineProperty(this, "resultsNumber", void 0);
  }
};
__decorate([Prop({
  default: ""
})], SearchCategoryTitle.prototype, "categoryTitle", void 0);
__decorate([Prop({
  default: 0
})], SearchCategoryTitle.prototype, "resultsNumber", void 0);
SearchCategoryTitle = __decorate([Component({})], SearchCategoryTitle);
export default SearchCategoryTitle;